// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let RelayEnv = require("../../RelayEnv.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let PageTitle = require("../../reason/common/PageTitle.bs.js");
let Belt_Option = require("@rescript/runtime/lib/js/Belt_Option.js");
let Belt_Result = require("@rescript/runtime/lib/js/Belt_Result.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let SystemMessage = require("../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Form__Validators = require("../../reason/common/Form/Form__Validators.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__Debouncer = require("../../vendor/re-formality/Formality__Debouncer.bs.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let RequestPasswordResetPageRelayQuery_graphql = require("../../__generated__/RequestPasswordResetPageRelayQuery_graphql.bs.js");
let RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql = require("../../__generated__/RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.bs.js");

let genericError = "There was a problem submitting your password reset request. Please try again or contact support";

let invalidEmailError = "There was a problem submitting your password reset request. Please verify if the email you entered is correct";

let convertVariables = RequestPasswordResetPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = RequestPasswordResetPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = RequestPasswordResetPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, RequestPasswordResetPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, RequestPasswordResetPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(RequestPasswordResetPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(RequestPasswordResetPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(RequestPasswordResetPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(RequestPasswordResetPageRelayQuery_graphql.node, convertVariables);

let Query_emailRegistrationStatus_decode = RequestPasswordResetPageRelayQuery_graphql.Utils.emailRegistrationStatus_decode;

let Query_emailRegistrationStatus_fromString = RequestPasswordResetPageRelayQuery_graphql.Utils.emailRegistrationStatus_fromString;

let Query = {
  emailRegistrationStatus_decode: Query_emailRegistrationStatus_decode,
  emailRegistrationStatus_fromString: Query_emailRegistrationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function validate(email) {
  let val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
      email: email
    }, undefined, "network-only");
  } catch (raw_exn) {
    let exn = Primitive_exceptions.internalToException(raw_exn);
    if (exn.RE_EXN_ID === "JsExn") {
      return {
        TAG: "Error",
        _0: genericError
      };
    }
    throw exn;
  }
  let match = val.emailRegistrationStatus;
  if (match === undefined) {
    return {
      TAG: "Error",
      _0: "email is not registered"
    };
  }
  let tmp = match.status;
  if (tmp === "REGISTERED") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return {
      TAG: "Error",
      _0: "email is not registered"
    };
  }
}

let ValidateEmailAsync = {
  Query: Query,
  validate: validate
};

let validators = {
  email: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: (param, param$1) => {
      let email = Form__Helpers.noneIfEmpty(param.email);
      if (email !== undefined) {
        if (Belt_Result.isOk(Form__Validators.isEmail(email))) {
          return {
            TAG: "Ok",
            _0: email
          };
        } else {
          return {
            TAG: "Error",
            _0: "Please enter a valid email."
          };
        }
      } else {
        return {
          TAG: "Error",
          _0: "is required"
        };
      }
    },
    validateAsync: Formality__Debouncer.make(700, param => {
      let dispatch = param[2];
      let value = param[0];
      let validate = (email, param) => param.validateEmail(email).then(res => {
        let tmp;
        tmp = res.TAG === "Ok" ? ({
            TAG: "Ok",
            _0: email
          }) : ({
            TAG: "Error",
            _0: res._0
          });
        return Promise.resolve(tmp);
      });
      Formality.Async.validateAsyncWithMetadata(value, param[1], validate, res => dispatch({
        TAG: "ApplyAsyncResultForEmailField",
        _0: value,
        _1: res
      }));
    }),
    eq: (a, b) => a === b
  }
};

function initialFieldsStatuses(input) {
  return {
    email: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    email: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      email: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  let value = fieldsStatuses.email;
  let match;
  match = typeof value !== "object" ? ({
      NAME: "Result",
      VAL: validators.email.validate(input, metadata)
    }) : (
      value.TAG === "Dirty" ? ({
          NAME: "Result",
          VAL: value._0
        }) : ({
          NAME: "Validating",
          VAL: value._0
        })
    );
  if (match.NAME !== "Result") {
    return {
      TAG: "Validating",
      fieldsStatuses: {
        email: match.NAME === "Result" ? ({
            TAG: "Dirty",
            _0: match.VAL,
            _1: "Shown"
          }) : ({
            TAG: "Validating",
            _0: match.VAL
          })
      },
      collectionsStatuses: undefined
    };
  }
  let emailResult = match.VAL;
  if (emailResult.TAG === "Ok") {
    return {
      TAG: "Valid",
      output: {
        email: emailResult._0
      },
      fieldsStatuses: {
        email: {
          TAG: "Dirty",
          _0: emailResult,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  } else {
    return {
      TAG: "Invalid",
      fieldsStatuses: {
        email: {
          TAG: "Dirty",
          _0: emailResult,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  }
}

function useForm(initialInput, metadata, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurEmailField" :
          let result = Formality.Async.validateFieldOfStringTypeOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators.email, status => ({
            email: status
          }));
          if (result === undefined) {
            return "NoUpdate";
          }
          let value = result.email;
          if (typeof value === "object" && value.TAG !== "Dirty") {
            let value$1 = value._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators.email.validateAsync([
                value$1,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: result,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
          break;
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let apply_validate = validateForm;
          let match$1 = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
          switch (match$1.TAG) {
            case "Valid" :
              let output = match$1.output;
              let error = state.formStatus;
              let tmp;
              tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
              return {
                TAG: "UpdateWithSideEffects",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: {
                    TAG: "Submitting",
                    _0: tmp
                  },
                  submissionStatus: "AttemptedToSubmit"
                },
                _1: param => {
                  let dispatch = param.dispatch;
                  onSubmit(output, {
                    notifyOnSuccess: input => dispatch({
                      TAG: "SetSubmittedStatus",
                      _0: input
                    }),
                    notifyOnFailure: error => dispatch({
                      TAG: "SetSubmissionFailedStatus",
                      _0: error
                    }),
                    reset: () => dispatch("Reset"),
                    dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
                  });
                }
              };
            case "Invalid" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: "Editing",
                  submissionStatus: "AttemptedToSubmit"
                }
              };
            case "Validating" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: state.formStatus,
                  submissionStatus: state.submissionStatus
                }
              };
          }
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateEmailField" :
          let nextInput = action._0(state.input);
          let nextFieldsStatuses = Formality.Async.validateFieldOfStringTypeOnChangeInOnChangeModeWithMetadata(nextInput, metadata, state.fieldsStatuses.email, state.submissionStatus, validators.email, status => ({
            email: status
          }));
          let value$2 = nextFieldsStatuses.email;
          if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
            let value$3 = value$2._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: nextInput,
                fieldsStatuses: nextFieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators.email.validateAsync([
                value$3,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: nextFieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "ApplyAsyncResultForEmailField" :
          let validator = validators.email;
          let x = state.fieldsStatuses.email;
          if (typeof x !== "object" || x.TAG === "Dirty" || !validator.eq(x._0, action._0)) {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  email: {
                    TAG: "Dirty",
                    _0: action._1,
                    _1: "Shown"
                  }
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  email: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  email: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateEmail: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateEmailField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurEmail: () => dispatch("BlurEmailField"),
    emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.email;
      return typeof tmp === "object";
    },
    valid: () => {
      let apply_validate = validateForm;
      let match = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
      switch (match.TAG) {
        case "Valid" :
          return true;
        case "Invalid" :
          return false;
        case "Validating" :
          return;
      }
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertVariables$1 = RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.Internal.convertVariables;

let convertResponse$1 = RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, RequestPasswordResetPageRelay_CreatePasswordResetTokenV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let CreatePasswordResetTokenV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$1
};

function RequestPasswordResetPageRelay(props) {
  let match = use$1();
  let createPasswordResetToken = match[0];
  let form = useForm({
    email: ""
  }, {
    validateEmail: validate
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    createPasswordResetToken({
      input: {
        email: param.email
      }
    }, undefined, undefined, undefined, (response, param) => {
      let match = response.createPasswordResetTokenV5;
      if (match === undefined) {
        return notifyOnFailure(genericError);
      }
      switch (match.__typename) {
        case "CreatePasswordResetTokenInvalidEmailError" :
          return notifyOnFailure(invalidEmailError);
        case "PasswordResetTokenCreated" :
          return notifyOnSuccess(undefined);
        case "__unselected" :
          return notifyOnFailure(genericError);
      }
    }, param => notifyOnFailure(genericError), undefined);
  });
  let match$1 = form.status;
  let tmp;
  let exit = 0;
  if (typeof match$1 !== "object" && match$1 === "Submitted") {
    tmp = JsxRuntime.jsx(SystemMessage.make, {
      id: "form_submitted",
      text: "Instructions to reset your password have been emailed to you. Please check your email.",
      type_: "success",
      secondary: true,
      handleOnDismiss: _id => {}
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let msg = form.status;
    let tmp$1;
    tmp$1 = typeof msg !== "object" || msg.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(SystemMessage.make, {
        id: "form_submitted",
        time: 5000,
        text: msg._0,
        type_: "error",
        dismissible: true,
        secondary: true,
        handleOnDismiss: _id => form.dismissSubmissionResult()
      });
    let match$2 = form.emailResult;
    let tmp$2;
    if (match$2 !== undefined && match$2.TAG !== "Validating") {
      let err = match$2._0;
      tmp$2 = err.TAG === "Ok" ? undefined : ({
          NAME: "Error",
          VAL: err._0
        });
    } else {
      tmp$2 = undefined;
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        tmp$1,
        JsxRuntime.jsxs("form", {
          children: [
            JsxRuntime.jsx(Form__Input.make, {
              labelText: "Your email",
              placeholderText: "Enter your email",
              onChange: event => form.updateEmail((param, value) => ({
                email: value
              }), event.target.value),
              onBlur: param => form.blurEmail(),
              disabled: form.submitting,
              status: Belt_Option.flatMap(form.emailResult, x => {
                if (x.TAG === "Validating") {
                  return;
                } else if (x._0.TAG === "Ok") {
                  return "ok";
                } else {
                  return "error";
                }
              }),
              value: form.input.email
            }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: tmp$2
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                disabled: form.submitting,
                _type: "submit",
                children: form.submitting ? "Submitting..." : "Reset password"
              }),
              className: "flex items-center justify-center mt-8"
            })
          ],
          className: "mt-2",
          onSubmit: e => {
            e.preventDefault();
            form.submit();
          }
        })
      ]
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "bg-white p-5 shadow rounded-md"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: "/login",
          children: "Login"
        }),
        className: "flex justify-center mt-8"
      }),
      JsxRuntime.jsx(PageTitle.make, {
        title: "Reset Password"
      })
    ]
  });
}

let make = RequestPasswordResetPageRelay;

let $$default = RequestPasswordResetPageRelay;

exports.genericError = genericError;
exports.invalidEmailError = invalidEmailError;
exports.ValidateEmailAsync = ValidateEmailAsync;
exports.FormConfig = FormConfig;
exports.CreatePasswordResetTokenV5Mutation = CreatePasswordResetTokenV5Mutation;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
